import Fsk8sUpsellGuard from "../../Upsell/Fsk8sUpsellGuard";
import { ClusterDashboardContextProvider } from "../Fsk8sPage/Table/context";

interface KubernetesLensGuardProps {
  children: React.ReactNode;
}

const KubernetesLensGuard = ({ children }: KubernetesLensGuardProps) => (
  <Fsk8sUpsellGuard>
    <ClusterDashboardContextProvider>{children}</ClusterDashboardContextProvider>
  </Fsk8sUpsellGuard>
);

export default KubernetesLensGuard;
